import React from 'react';
import Footer from '../FooterComponent/Footer';
import Body from './Body';
import '../../styles/HomePage.css';
import '../../styles/HoverFocus.css';
import '../../styles/ProductHeader.css';
import '../../styles/common/CommonHome.css';
import { connect } from "react-redux";
import { Helmet } from "react-helmet";
import ReactHtmlParser from "react-html-parser";
import ErrorHomePage from "../ErrorPageComponent/ErrorHomePage";
import transform from '../../transform/index';
import {doGetCall} from '../../config/rest';
import {digital} from '../../DigitalData.js';

class HomePage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showProductsLink: true,
      homeData: null
    };
  }
  fetchHomePageData = (api_url) => {
    doGetCall(api_url)
    .then(res => {this.setState({homeResponse: res[0], homeData: res[0].acf, error: null})})
    .catch(err => {this.setState({error: err})})
  }
  componentDidMount() {
    digital();
    window.scrollTo(0, 0);
    if(global.preview)
      this.fetchHomePageData(`/wp-json/previews/v1/preview?page_id=${global.id}`)
    else
      this.fetchHomePageData('/wp-json/wp/v2/pages?slug=home')
  }

  render() {
    const { footerData } = this.props;
    if (this.state.error) {
      return (
        <div className="home-page">
          <ErrorHomePage/>
        </div>
      );
    }
    return (
      <div>
        {this.state.homeResponse && <Helmet>
          {ReactHtmlParser(this.state.homeResponse.yoast_head,transform.options)}
          <meta class="swiftype" name="page_type" data-type="enum" content="Other" />
        </Helmet>}
        {this.state.homeData &&
          <Body backgroundImages={this.state.homeData.background_images}
          homePageComponents={this.state.homeData.components}
          blurBackground={this.props.blurBackground} />
        }
        {this.state.homeData &&
        <Footer leftColData={footerData.footer !== undefined && footerData.footer['footer-left-menu']}
        showSocialIcons={this.state.showProductsLink}
        showFooterNote={this.state.homeData.show_citizensbank_footnote}/>}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  footerData: state.HeaderFooterData.items
});

export default connect(mapStateToProps)(HomePage);
